<template>
  <InputRadioGroup
    legend="Bindningstid"
    type-class="product-page"
    class="mt-24"
  >
    <InputRadioButton
      id="12"
      key="12"
      v-model="familyStore.inputs.bindingPeriodRadioValue"
      value="12"
      label="12 månader"
      aria-label="12 månader bindningstid"
      :simple-label="true"
      group-name="bindPeriod"
    />
    <InputRadioButton
      id="0"
      key="0"
      v-model="familyStore.inputs.bindingPeriodRadioValue"
      value="0"
      label="0 månader"
      aria-label="0 månader bindningstid"
      :simple-label="true"
      group-name="bindPeriod"
    />
  </InputRadioGroup>
</template>

<script lang="ts" setup>
const familyStore = useFamilyStore();
</script>

<style scoped></style>
